import type { FC } from 'react';
import { CircleDashed, PlayCircle, CheckCircle2, AlertTriangle } from 'lucide-react';
import MilestoneCard, { type Milestone } from './MilestoneCard';

const COLUMNS: { key: string; label: string; icon: FC<{ className?: string }> }[] = [
  { key: 'planned', label: 'Planifie', icon: CircleDashed },
  { key: 'in_progress', label: 'En cours', icon: PlayCircle },
  { key: 'completed', label: 'Termine', icon: CheckCircle2 },
  { key: 'blocked', label: 'Bloque', icon: AlertTriangle },
];

interface RoadmapKanbanViewProps {
  milestones: Milestone[];
  onEdit: (m: Milestone) => void;
  onDelete: (id: string) => void;
}

const RoadmapKanbanView: FC<RoadmapKanbanViewProps> = ({ milestones, onEdit, onDelete }) => {
  const grouped = COLUMNS.map((col) => ({
    ...col,
    items: milestones.filter((m) => m.status === col.key),
  }));

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {grouped.map((col) => {
        const ColIcon = col.icon;
        return (
          <div key={col.key} className="space-y-3">
            {/* Column header */}
            <div className="flex items-center gap-2 px-1">
              <ColIcon className="w-4 h-4 text-slate-500 dark:text-slate-400" />
              <span className="text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">
                {col.label}
              </span>
              <span className="ml-auto text-xs font-medium text-slate-400 dark:text-slate-500 tabular-nums">
                {col.items.length}
              </span>
            </div>

            {/* Cards */}
            <div className="space-y-2 min-h-[120px]">
              {col.items.length === 0 && (
                <div className="rounded-lg border-2 border-dashed border-slate-200 dark:border-slate-700 p-4 text-center">
                  <span className="text-xs text-slate-400 dark:text-slate-500">Aucun jalon</span>
                </div>
              )}
              {col.items.map((m) => (
                <MilestoneCard key={m.id} milestone={m} onEdit={onEdit} onDelete={onDelete} />
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default RoadmapKanbanView;
